import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import CompetenciesTypeServices from "./CompetenciesType.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getCompetenciesType = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TYPE,
      payload: true,
    });
    const resp = await CompetenciesTypeServices.getCompetenciesType(filters);
    dispatch({
      type: actions.GET_COMPETENCIES_TYPE,
      payload: {
        competenciesTypes: resp.data.data,
        competenciesTypesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.COMPETENCIES_TYPE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.COMPETENCIES_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TYPE,
      payload: false,
    });
  }
};

export const getCompetenciesTypeById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TYPE,
      payload: true,
    });
    const resp = await CompetenciesTypeServices.getCompetenciesTypeById(id);
    dispatch({
      type: actions.GET_COMPETENCIES_TYPE,
      payload: {
        competenciesType: resp.data
      },
    });
    dispatch({
      type: actions.COMPETENCIES_TYPE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COMPETENCIES_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TYPE,
      payload: false,
    });
  }
};

export const saveCompetenciesType = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_COMPETENCIES_TYPE,
      payload: true,
    });
    const resp = await CompetenciesTypeServices.saveCompetenciesType(data);
    const { competenciesTypes, competenciesTypesLength } = getState().competenciesType;
    const _competenciesType = [...competenciesTypes, resp.data];
    dispatch({
      type: actions.GET_COMPETENCIES_TYPE,
      payload: {
        competenciesTypes: _competenciesType,
        competenciesTypesLength: competenciesTypesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_COMPETENCIES_TYPE,
      payload: false,
    });
  }
};

export const editCompetenciesType = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TYPE,
      payload: true,
    });
    const resp = await CompetenciesTypeServices.editCompetenciesType(id, data);
    const { competenciesTypes, competenciesTypesLength } = getState().competenciesType;
    competenciesTypes[index] = resp.data;
    dispatch({
      type: actions.GET_COMPETENCIES_TYPE,
      payload: {
        competenciesTypes: competenciesTypes,
        competenciesTypesLength: competenciesTypesLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TYPE,
      payload: false,
    });
  }
};

export const deleteCompetenciesType = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TYPE,
      payload: true,
    });
    await CompetenciesTypeServices.deleteCompetenciesType(id);
    const { competenciesTypes, competenciesTypesLength } = getState().competenciesType;
    competenciesTypes.splice(index, 1);
    dispatch({
      type: actions.GET_COMPETENCIES_TYPE,
      payload: {
        competenciesTypes: competenciesTypes,
        competenciesTypesLength: competenciesTypesLength - 1,
      },
    });
    dispatch({
      type: actions.COMPETENCIES_TYPE_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COMPETENCIES_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TYPE,
      payload: false,
    });
  }
};
